import { render, staticRenderFns } from "./listShareUser.vue?vue&type=template&id=2e0faf7a"
import script from "./listShareUser.vue?vue&type=script&lang=js"
export * from "./listShareUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports